module.exports = __webpack_public_path__ + "static/logo-minsante-b3f99a8eed31d592b29fd8aef39ece5c.png";